import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mb-0 toggle_area",
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_2 = ["checked", "disabled"];
export default {
  __name: 'AppgSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    _class: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const input = ({
      target
    }) => {
      emit('update:modelValue', target.checked);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["ui_switch", __props._class])
      }, [_createElementVNode("label", _hoisted_1, [_createElementVNode("input", {
        type: "checkbox",
        checked: __props.modelValue,
        onInput: input,
        disabled: __props.disabled
      }, null, 40, _hoisted_2), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "slider"
      }, null, -1))])], 2);
    };
  }
};